import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import image from '../../img/bg5.jpg';
import { CardBody } from '../Card/CardBody';
import { Card } from '../Card/Card';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import Grid from '@material-ui/core/Grid';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    padding: '20px',
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  resource: {
    position: 'relative',
    borderRadius: '10px',
  },
  overlay: {
    position: 'absolute',
    background: 'rgba(0, 0, 0, 0.5)' /* Black see-through */,
    color: '#f1f1f1',
    opacity: '1',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 10px',
    },
    [theme.breakpoints.up('sm')]: {
      padding: '30px 20px',
    },
    height: '280px',
    textAlign: 'center',
    width: '100%',
    top: '0',
    left: '0',
  },
  image: {
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    alignItems: 'center',
    justifyContent: 'center',
    height: '280px',

    width: '100%',
  },
  cardHeader: {
    color: 'white',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.75rem',
    },
  },
  cardSubHeader: {
    color: 'white',
    margin: '20px',
    fontSize: '1rem',
  },
  button: {
    padding: '10px 20px',
    borderRadius: '20px',
  },
}));

export const BlogCard = (props) => {
  const classes = useStyles();
  const { title, description, id } = props.blogDetails;
  const navigate = useNavigate();
  console.log(props);
  return (
    <Card className={classes.resource} elevation={2}>
      <div className={classes.image} />
      <CardBody className={classes.overlay}>
        <Grid container>
          <Grid item xs={12}>
            {title && <Typography className={classes.cardHeader}>{title}</Typography>}
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.cardSubHeader}>
              {description.substring(0, 150)}...
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              size="large"
              color="primary"
              onClick={() => navigate(`/app/blog/${id}`, { replace: true })}
              startIcon={<FormatAlignLeftIcon />}
              classes={{ root: classes.button }}
            >
              Read more
            </Button>
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  );
};
